import { Component, OnInit, OnDestroy } from '@angular/core';

import { Subscription, timer } from 'rxjs';
import { debounce, takeWhile } from 'rxjs/operators';

import { LoaderService } from './loader.service';
import { LoaderState } from './loader';
@Component({
  selector: 'db-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy {
  show = false;

  private subscription: Subscription;

  constructor(private loaderService: LoaderService) { }

  ngOnInit() {
    this.subscription = this.loaderService.loaderState
    .pipe(
      // Delay by 1 second to prevent
      // flash of loader on fast loads
      debounce(() => timer(50)),
      takeWhile((result) => result.show <= true),
    ).subscribe((state) => {
        this.show = state.show;
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
